"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupGridExtension = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const stargate_1 = require("@cosmjs/stargate");
const query_1 = require("../codec/cyber/grid/v1beta1/query");
function setupGridExtension(base) {
    const rpc = (0, stargate_1.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        grid: {
            sourceRoutes: async (source) => {
                const response = await queryService.SourceRoutes({ source: source });
                return response;
            },
            destinationRoutes: async (destination) => {
                const response = await queryService.DestinationRoutes({ destination: destination });
                return response;
            },
            destinationRoutedEnergy: async (destination) => {
                const response = await queryService.DestinationRoutedEnergy({ destination: destination });
                return response;
            },
            sourceRoutedEnergy: async (source) => {
                const response = await queryService.SourceRoutedEnergy({ source: source });
                return response;
            },
            route: async (source, destination) => {
                const response = await queryService.Route({
                    source: source,
                    destination: destination,
                });
                return response;
            },
            routes: async () => {
                const response = await queryService.Routes({});
                return response;
            },
            params: async () => {
                const response = await queryService.Params({});
                return response;
            },
        },
    };
}
exports.setupGridExtension = setupGridExtension;
//# sourceMappingURL=grid.js.map